import React from 'react';
import { Layout, Menu, Typography, Row, Col, Button, Image } from 'antd';
import './static.css';
// import Login from '../login';
import { useNavigate } from "react-router-dom";
const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

const APage = () => {

  const navigate = useNavigate();
  const Login = () => {
    navigate("/login");
  }

  const Policy = () => {
    navigate("/policy");
  }

  const About = () => {
    navigate("/about");
  }

  return (
    <Layout className="layout">
      <Header style={{ background: '#ffffff' }}>
        <div className="logo">Data <span className="highlight">- AI</span>
          <Image
            src={require('../../assets/images/static16.png')}
            alt="Description"
            style={{ width: 200, height: 75 }}
          />
        </div>

        <button className="sign-in" onClick={Login}>Sign In</button>
      </Header>
      <Content style={{ padding: '0 50px' }}>
        <div className="site-layout-content">
          <Row gutter={[16, 16]}>
            <Col span={12} style={{ paddingLeft: '12vw' }}>
              <Title level={1} style={{ color: '#007BFF', fontWeight: 'bold', paddingTop: '10vh' }}>Data Analysis</Title>
              <Title level={2} style={{ fontWeight: 'bold' }}>Question and Answer <br />
                AI Data Analysis<br /> Platform</Title>
              <Paragraph >Your 7x24 hour exclusive AI data analyst</Paragraph>
              <Paragraph >Make data insights as simple as a search conversation</Paragraph>
            </Col>
            <Col span={12}>
              <Image
                src={require('../../assets/images/static01.png')}
                alt="Description"
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="features" style={{ paddingTop: '15vh' }}>
            <Col span={6}>
              <div className="upload-card">
                <Image
                  src={require('../../assets/images/static02.png')}
                  alt="Description"
                />
                <div className="upload-text">
                  Upload data files
                </div>
              </div>
            </Col>
            <Col span={6}>
              <div className="upload-card">
                <Image
                  src={require('../../assets/images/static03.png')}
                  alt="Description"
                />
                <div className="upload-text">
                  Connect to database
                </div>
              </div>

            </Col>
            <Col span={6}>
              <div className="upload-card">
                <Image
                  src={require('../../assets/images/static04.png')}
                  alt="Description"
                />
                <div className="upload-text">
                  Data Analysis Report
                </div>
              </div>

            </Col>
            <Col span={6}>
              <div className="upload-card">
                <Image
                  src={require('../../assets/images/static05.png')}
                  alt="Description"
                />
                <div className="upload-text">
                  Data chart generation
                </div>
              </div>

            </Col>
          </Row>
          <Title level={1} className="section-title">Efficient data insights</Title>
          <Row gutter={[16, 16]}>
            <Col span={9}>
              <Image src={require('../../assets/images/static06.png')} alt="Data Insight" />
            </Col>
            <Col span={15}>
              <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
                <Col span={12}>
                  <Image src={require('../../assets/images/static07.png')} alt="Database Connection" />
                </Col>
                <Col span={12}>
                  <Image src={require('../../assets/images/static08.png')} alt="Chat with Data" />
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Image src={require('../../assets/images/static09.png')} alt="Data Chart Generation" />
                </Col>
                <Col span={12}>
                  <Image src={require('../../assets/images/static10.png')} alt="Sales Performance" />

                </Col>
              </Row>
            </Col>
          </Row>



          <Title level={1} className="section-title">Upload files / Connect to database</Title>


          <div className="uploads" >

            <div className="block_7 flex-col">
              <div className="image-text_45 flex-row justify-between">
                <img
                  className="image_15"
                  alt=''
                  src={require('../../assets/images/static17.png')}
                />
                <span className="text-group_4">
                  Upload&nbsp;the&nbsp;data&nbsp;files&nbsp;that&nbsp;<br />need&nbsp;to&nbsp;besorted&nbsp;out
                </span>
              </div>
              <img
                className="image_9"
                alt=''
                src={
                  require('../../assets/images/static.png')
                }
              />
              <div className="image-text_46 flex-row justify-between">
                <img
                  className="image_16"
                  alt=''
                  src={require('../../assets/images/static18.png')}
                />
                <span className="text-group_5">Speak&nbsp;out&nbsp;your&nbsp;needs&nbsp;to&nbsp;Ai</span>
              </div>
              <img
                className="image_9"
                alt=''
                src={
                  require('../../assets/images/static.png')
                }
              />
              <div className="image-text_47 flex-row justify-between">
                <img
                  className="image_17"
                  alt=''
                  src={require('../../assets/images/static19.png')}
                />
                <span className="text-group_6">Complete&nbsp;data&nbsp;sorting&nbsp;and&nbsp;provide&nbsp;feedback</span>
              </div>
              <img
                className="label_10"
                alt=''
                src={
                  require('../../assets/images/static.png')
                }
              />
              <img
                className="label_11"
                alt=''
                src={
                  require('../../assets/images/static.png')
                }
              />
            </div>
            <div className="block_8 flex-col">
              <div className="image-text_48 flex-row justify-between">
                <img
                  className="image_18"
                  alt=''
                  src={require('../../assets/images/static20.png')}
                />
                <span className="text-group_7">Connect&nbsp;to&nbsp;database</span>
              </div>
              <img
                className="image_10"
                alt=''
                src={require('../../assets/images/static.png')}
              />
              <div className="image-text_49 flex-row justify-between">
                <img
                  className="image_19"
                  alt=''
                  src={require('../../assets/images/static21.png')}
                />
                <span className="text-group_8">Speak&nbsp;out&nbsp;your&nbsp;needs&nbsp;to&nbsp;Ai</span>
              </div>
              <img
                className="image_11"
                alt=''
                src={require('../../assets/images/static.png')}
              />
              <div className="image-text_50 flex-row justify-between">
                <img
                  className="image_20"
                  alt=''
                  src={require('../../assets/images/static22.png')}
                />
                <span className="text-group_9">
                  Complete&nbsp;sorting&nbsp;and&nbsp;feedback&nbsp;based&nbsp;on&nbsp;database&nbsp;data&nbsp;information
                </span>
              </div>
              <img
                className="label_15"
                alt=''
                src={require('../../assets/images/static.png')}
              />
              <img
                className="label_16"
                alt=''
                src={require('../../assets/images/static.png')}
              />

            </div>
          </div>

          <div className="box_15 flex-col">
            <div>
              <div className="text-group_34 flex-col justify-between">
                <span className="text_24">What&nbsp;our&nbsp;customers&nbsp;said</span>
                <br />
                <span className="text_25">
                  We&nbsp;improve&nbsp;the&nbsp;digital&nbsp;life&nbsp;of&nbsp;thousands&nbsp;of&nbsp;people.
                </span>
              </div>
              <div className="box_33 flex-row justify-between">
                <div className="section_8 flex-col">
                  <div className="image-text_51 flex-row justify-between">
                    <img
                      className="image_12"
                      alt=''
                      src={require('../../assets/images/user1.png')}
                    />
                    <div className="text-group_35 flex-col justify-between">
                      <span className="text_26">Xavier&nbsp;Lecomte</span>
                      <br />
                      <span className="text_27">operation&nbsp;analyst</span>
                    </div>
                  </div>
                  <br />
                  <span className="text_28">
                    As&nbsp;an&nbsp;analyst,&nbsp;the&nbsp;AI&nbsp;platform&nbsp;simplifies&nbsp;data&nbsp;handling.&nbsp;Pattern&nbsp;detection&nbsp;and&nbsp;automated&nbsp;reports&nbsp;save&nbsp;time,&nbsp;enhancing&nbsp;productivity&nbsp;and&nbsp;focus&nbsp;on&nbsp;strategy.
                  </span>
                </div>
                <div className="section_9 flex-col">
                  <div className="image-text_52 ">
                    <img
                      className="image_13"
                      alt=''
                      src={require('../../assets/images/user2.png')}
                    />
                    <div className="text-group_36 flex-col justify-between">
                      <span className="text_29">Denise&nbsp;Chapman</span>
                      <br />
                      <span className="text_30">CEO&nbsp;of&nbsp;a&nbsp;certain&nbsp;company</span>
                    </div>
                  </div>
                  <br />
                  <span className="text_31">
                    As&nbsp;CEO,&nbsp;the&nbsp;AI&nbsp;data&nbsp;platform&nbsp;revolutionizes&nbsp;our&nbsp;decision-making.&nbsp;Real-time&nbsp;analytics&nbsp;and&nbsp;seamless&nbsp;integration&nbsp;make&nbsp;data&nbsp;accessible&nbsp;and&nbsp;actionable.&nbsp;It's&nbsp;driving&nbsp;our&nbsp;growth&nbsp;and&nbsp;we're&nbsp;thrilled.
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="money" >
            <div className="block_9 flex-col">
              <span className="text_32">1&nbsp;Points</span>
              <div className="text-wrapper_16 flex-row justify-between">
                <span className="text_33">$1</span>
                <span className="text_34">/points</span>
              </div>
              <br />

              <Button className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_53 flex-row justify-between">
                <img
                  className="thumbnail_1"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}
                />
                &nbsp;
                <span className="text-group_13">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_54 flex-row justify-between">
                <img
                  className="thumbnail_2"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}
                />
                &nbsp;
                <span className="text-group_14">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_55 flex-row justify-between">
                <img
                  className="thumbnail_3"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}
                />
                &nbsp;
                <span className="text-group_15">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_56 flex-row justify-between">
                <img
                  className="thumbnail_4"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}
                />
                &nbsp;
                <span className="text-group_16">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
            <div className="block_10 flex-col">
              <div className="group_26 flex-row justify-between">
                <span className="text_36">7&nbsp;Points</span>
                <div className="box_18 flex-col">
                  <div className="text-wrapper_10 flex-col">
                    <span className="text_37">Save&nbsp;50%</span>
                  </div>
                  <span className="text_38">Limited&nbsp;time&nbsp;offer</span>
                </div>
              </div>
              <div className="group_27 flex-row justify-between">
                <div className="text-group_37 flex-col justify-between">
                  <span className="text_39">$5</span>
                  <span className="text_40">/points</span>
                </div>
              </div>
              <Button type="primary" className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_57 flex-row justify-between">
                <img
                  className="thumbnail_5"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}
                />
                &nbsp;
                <span className="text-group_18">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_58 flex-row justify-between">
                <img
                  className="thumbnail_6"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}

                />
                &nbsp;
                <span className="text-group_19">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_59 flex-row justify-between">
                <img
                  className="thumbnail_7"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}

                />
                &nbsp;
                <span className="text-group_20">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_60 flex-row justify-between">
                <img
                  className="thumbnail_8"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}

                />
                &nbsp;
                <span className="text-group_21">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
            <div className="block_11 flex-col">
              <div className="group_28 flex-row justify-between">
                <span className="text_42">13&nbsp;Points</span>
                <div className="block_12 flex-col">
                  <div className="text-wrapper_11 flex-col">
                    <span className="text_43">Save&nbsp;30%</span>
                  </div>
                  <span className="text_44">Limited&nbsp;time&nbsp;offer</span>
                </div>
              </div>
              <div className="text-wrapper_17 flex-row justify-between">
                <span className="text_45">$10</span>
                <span className="text_46">/points</span>
              </div>
              <br />
              <Button className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_61 flex-row justify-between">
                <img
                  className="thumbnail_9"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}

                />
                &nbsp;
                <span className="text-group_22">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_62 flex-row justify-between">
                <img
                  className="thumbnail_10"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}

                />
                &nbsp;
                <span className="text-group_23">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_63 flex-row justify-between">
                <img
                  className="thumbnail_11"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}

                />
                &nbsp;
                <span className="text-group_24">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_64 flex-row justify-between">
                <img
                  className="thumbnail_12"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}

                />
                &nbsp;
                <span className="text-group_25">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
          </div>
          <div className="money" >
            <div className="block_9 flex-col">
              <span className="text_32">25&nbsp;Points</span>
              <div className="text-wrapper_16 flex-row justify-between">
                <span className="text_33">$20</span>
                <span className="text_34">/points</span>
              </div>
              <br />
              <span className="text_35">

              </span>
              <Button className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_53 flex-row justify-between">
                <img
                  className="thumbnail_1"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}
                />
                &nbsp;
                <span className="text-group_13">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_54 flex-row justify-between">
                <img
                  className="thumbnail_2"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}
                />
                &nbsp;
                <span className="text-group_14">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_55 flex-row justify-between">
                <img
                  className="thumbnail_3"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}
                />
                &nbsp;
                <span className="text-group_15">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_56 flex-row justify-between">
                <img
                  className="thumbnail_4"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}
                />
                &nbsp;
                <span className="text-group_16">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
            <div className="block_10 flex-col">
              <div className="group_26 flex-row justify-between">
                <span className="text_36">60&nbsp;Points</span>
                <div className="box_18 flex-col">
                  <div className="text-wrapper_10 flex-col">
                    <span className="text_37">Save&nbsp;50%</span>
                  </div>
                  <span className="text_38">Limited&nbsp;time&nbsp;offer</span>
                </div>
              </div>
              <div className="group_27 flex-row justify-between">
                <div className="text-group_37 flex-col justify-between">
                  <span className="text_39">$50</span>
                  <span className="text_40">/points</span>
                </div>

              </div>
              <br />
              <Button type="primary" className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_57 flex-row justify-between">
                <img
                  className="thumbnail_5"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}
                />
                &nbsp;
                <span className="text-group_18">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_58 flex-row justify-between">
                <img
                  className="thumbnail_6"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}

                />
                &nbsp;
                <span className="text-group_19">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_59 flex-row justify-between">
                <img
                  className="thumbnail_7"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}

                />
                &nbsp;
                <span className="text-group_20">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_60 flex-row justify-between">
                <img
                  className="thumbnail_8"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}

                />
                &nbsp;
                <span className="text-group_21">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
            <div className="block_11 flex-col">
              <div className="group_28 flex-row justify-between">
                <span className="text_42">120&nbsp;Points</span>
                <div className="block_12 flex-col">
                  <div className="text-wrapper_11 flex-col">
                    <span className="text_43">Save&nbsp;30%</span>
                  </div>

                </div>
              </div>
              <div className="text-wrapper_17 flex-row justify-between">
                <span className="text_45">$100</span>
                <span className="text_46">/points</span>
              </div>
              <br />

              <Button className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_61 flex-row justify-between">
                <img
                  className="thumbnail_9"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}

                />
                &nbsp;
                <span className="text-group_22">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_62 flex-row justify-between">
                <img
                  className="thumbnail_10"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}

                />
                &nbsp;
                <span className="text-group_23">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_63 flex-row justify-between">
                <img
                  className="thumbnail_11"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}

                />
                &nbsp;
                <span className="text-group_24">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_64 flex-row justify-between">
                <img
                  className="thumbnail_12"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}

                />
                &nbsp;
                <span className="text-group_25">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
          </div>
          <div className="money" >
            <div className="block_9 flex-col">
              <span className="text_32">600&nbsp;Points</span>
              <div className="text-wrapper_16 flex-row justify-between">
                <span className="text_33">$500</span>
                <span className="text_34">/points</span>
              </div>


              <Button className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_53 flex-row justify-between">
                <img
                  className="thumbnail_1"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}
                />
                &nbsp;
                <span className="text-group_13">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_54 flex-row justify-between">
                <img
                  className="thumbnail_2"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}
                />
                &nbsp;
                <span className="text-group_14">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_55 flex-row justify-between">
                <img
                  className="thumbnail_3"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}
                />
                &nbsp;
                <span className="text-group_15">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_56 flex-row justify-between">
                <img
                  className="thumbnail_4"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}
                />
                &nbsp;
                <span className="text-group_16">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
            <div className="block_10 flex-col">
              <div className="group_26 flex-row justify-between">
                <span className="text_36">800&nbsp;Points</span>
                <div className="box_18 flex-col">
                  <div className="text-wrapper_10 flex-col">
                    <span className="text_37">Save&nbsp;50%</span>
                  </div>
                  <span className="text_38">Limited&nbsp;time&nbsp;offer</span>
                </div>
              </div>
              <div className="group_27 flex-row justify-between">
                <div className="text-group_37 flex-col justify-between">
                  <span className="text_39">$700</span>
                  <span className="text_40">/points</span>
                </div>

              </div>
              <br />
              <Button type="primary" className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_57 flex-row justify-between">
                <img
                  className="thumbnail_5"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}
                />
                &nbsp;
                <span className="text-group_18">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_58 flex-row justify-between">
                <img
                  className="thumbnail_6"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}

                />
                &nbsp;
                <span className="text-group_19">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_59 flex-row justify-between">
                <img
                  className="thumbnail_7"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}

                />
                &nbsp;
                <span className="text-group_20">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_60 flex-row justify-between">
                <img
                  className="thumbnail_8"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}

                />
                &nbsp;
                <span className="text-group_21">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
            <div className="block_11 flex-col">
              <div className="group_28 flex-row justify-between">
                <span className="text_42">1200&nbsp;Points</span>
                <div className="block_12 flex-col">
                  <div className="text-wrapper_11 flex-col">
                    <span className="text_43">Save&nbsp;30%</span>
                  </div>
                  <span className="text_44">Limited&nbsp;time&nbsp;offer</span>
                </div>
              </div>
              <div className="text-wrapper_17 flex-row justify-between">
                <span className="text_45">$1000</span>
                <span className="text_46">/points</span>
              </div>
              <br />
              <Button className="logout-button" size="large" style={{ width: 150, marginLeft: 100 }} onClick={Login}>
                Buy Now
              </Button>
              <div className="image-text_61 flex-row justify-between">
                <img
                  className="thumbnail_9"
                  alt=''
                  src={require('../../assets/images/thumbnail_1.png')}

                />
                &nbsp;
                <span className="text-group_22">Priority&nbsp;access&nbsp;to&nbsp;new&nbsp;tools</span>
              </div>
              <div className="image-text_62 flex-row justify-between">
                <img
                  className="thumbnail_10"
                  alt=''
                  src={require('../../assets/images/thumbnail_2.png')}

                />
                &nbsp;
                <span className="text-group_23">Unlimited&nbsp;use</span>
              </div>
              <div className="image-text_63 flex-row justify-between">
                <img
                  className="thumbnail_11"
                  alt=''
                  src={require('../../assets/images/thumbnail_3.png')}

                />
                &nbsp;
                <span className="text-group_24">Priority&nbsp;customer&nbsp;support</span>
              </div>
              <div className="image-text_64 flex-row justify-between">
                <img
                  className="thumbnail_12"
                  alt=''
                  src={require('../../assets/images/thumbnail_4.png')}

                />
                &nbsp;
                <span className="text-group_25">Regular&nbsp;Activities&nbsp;and&nbsp;Discounts</span>
              </div>
            </div>
          </div>

          <div className='adds'>
            <div className='foot'>
              <Image
                src={require('../../assets/images/static12.png')}
                alt="Description"
              />

            </div>
            <div className='footer'>
              <div className='footer-left'>
                <div className="logo">Data <span className="highlight">- AI</span>
                  <br />
                  <span style={{ fontSize: '16px' }}>Email：caihui0240@gmail.com</span>
                </div>


              </div>
              <div className='footer-right'>
                <p>Home</p>
                <p onClick={Policy} style={{ cursor: 'pointer' }}>Privacy Policy</p>
                <p onClick={About} style={{ cursor: 'pointer' }}> About</p>
              </div>
            </div>
          </div>

        </div>
      </Content>
      <div className='fixlogin'>
        <div className='fixsmall'>
          <Title level={3} style={{ fontWeight: 'bold' }}>Empower Your Data Insights with AI-Driven Analytics</Title>
          <div>
            <Button type="text" size='large'>Register</Button>
            <Button type="primary" size='large' onClick={Login}>Login</Button>
          </div>
        </div>
      </div>


    </Layout >
  );
};

export default APage;
